import { all } from 'redux-saga/effects';
import bankAccountWatcher from './bank-account-saga';

export default function* rootSaga(action) {
	yield all([bankAccountWatcher(action)]);
}
